import { render } from "./CIS-UX-Example.vue?vue&type=template&id=553d8a76&scoped=true"
import script from "./CIS-UX-Example.vue?vue&type=script&lang=js"
export * from "./CIS-UX-Example.vue?vue&type=script&lang=js"

import "./CIS-UX-Example.vue?vue&type=style&index=0&id=553d8a76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553d8a76"]])

export default __exports__